import { render, staticRenderFns } from "./NovelVoicePlayerV2.vue?vue&type=template&id=4fbc18ca&scoped=true&"
import script from "./NovelVoicePlayerV2.vue?vue&type=script&lang=js&"
export * from "./NovelVoicePlayerV2.vue?vue&type=script&lang=js&"
import style0 from "./NovelVoicePlayerV2.vue?vue&type=style&index=0&id=4fbc18ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc18ca",
  null
  
)

export default component.exports